module.exports = __webpack_public_path__ + "static/img/detail4.acc58f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/detail4.jpg
// module id = t5ZS
// module chunks = 0